import React, { useEffect } from 'react';
import PropTypes from 'prop-types'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import OrganisationComponentRoot from './OrganisationComponentRoot'
import packageJson from '../package.json'
import 'navigator.sendbeacon'

const { version: APP_VERSION, name: APP_NAME } = packageJson

const OrganisationComponent = (props) => {

  useEffect(() => {
    navigator.sendBeacon(
      'https://api.apps.austauschkompass.de/' + APP_NAME + '/track',
      JSON.stringify({ version: APP_VERSION, url: document.location.href })
    )
  }, [])

  const queryClient = props.queryClient || new QueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <OrganisationComponentRoot {...props} />
    </QueryClientProvider>
  )}

OrganisationComponent.propTypes = {
  queryClient: PropTypes.instanceOf(QueryClient),
  businessArea: PropTypes.string.isRequired,
  crmApiUrl: PropTypes.string.isRequired,
  crmApiToken: PropTypes.string.isRequired,
  ratingApiUrl: PropTypes.string.isRequired,
  userFilter: PropTypes.bool,
  filter: PropTypes.shape({
    countryCode: PropTypes.string,
    targetGroup: PropTypes.string,
    limit: PropTypes.string,
  }),
  organisationLinkPrefix: PropTypes.string,
  context: PropTypes.string,
  children: PropTypes.func,
}

export default OrganisationComponent
